import React from 'react';

import { SimpleImage } from '$partials/media';
import { PropertyPriceText } from '$partials/properties';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/items').NewHomeListingItem}
 */

const NewHomeListingItem = (props) => {
    return (
        <div
            className={`expand-interaction flex flex-col gap-16 w-full group ${props.className || ''}`}>
            {/* Property Image */}
            {props.listingImage && (
                <div className='aspect-[3/2] w-full overflow-hidden rounded relative'>
                    <SimpleImage
                        {...props.listingImage}
                        className='w-full h-full object-cover transition-transform duration-300'/>
                </div>
            )}

            {/* Property Details */}
            <div className='flex flex-col gap-16 w-full'>
                {/* displayAddress and Price */}
                <div className='flex flex-col gap-y-4 w-full'>
                    <div className='flex gap-8 items-center w-full'>
                        {props.displayAddress &&
                            <p className='hidden sm:block type-style-eyebrow flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-main-text-primary'>
                                {props.displayAddress}
                            </p>
                        }

                        {(!isNaN(props.price) && props.price !== 0) &&
                            <div className='flex flex-col h-20 justify-center shrink-0'>
                                <div className='bg-tag-main-background border border-tag-main-border rounded flex h-24 items-center justify-center px-8 py-8'>
                                    <p className='type-style-eyebrow text-main-brand-text'>
                                        <PropertyPriceText
                                            pageType={'SalePropertyDetailPage'}
                                            prefix='From: '
                                            price={props.price}
                                            priceCurrency={props.priceCurrency} />
                                    </p>
                                </div>
                            </div>
                        }
                    </div>

                    {props.displayAddress && (
                        <p className='block sm:hidden mt-16 type-style-eyebrow flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-main-text-primary'>
                            {props.displayAddress}
                        </p>
                    )}

                    {/* Bed/Bath/livingAreaMeters Details */}
                    <div className='flex-1 flex gap-16 items-center type-style-eyebrow text-main-text-primary'>
                        {props.noProperties && (
                            <p>
                                {`${props.noProperties} Properties`}
                            </p>
                        )}
                        {props.noBeds && (
                            <p className='shrink-0'>
                                {`${props.noBeds} bed`}
                            </p>
                        )}
                        {props.noBaths && (
                            <p className='shrink-0'>
                                {`${props.noBaths } bath`}
                            </p>
                        )}
                    </div>
                </div>

                {/* title and Tags */}
                <div className='flex flex-col gap-24 w-full pr-0 md:pr-40'>
                    <a
                        className='expand-interaction__action type-style-body-l text-main-text-primary whitespace-pre-wrap'
                        href={props.url}>
                        {props.title}
                    </a>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default NewHomeListingItem;
